import React from 'react';
import { useTranslation } from "react-i18next";
import { db } from "../controllers/DB";
import { generateID } from "../controllers/misc";
import Api from "../api/api-wizard";

function Register() {

  const saveAccount = (steps) => {

    if (typeof (steps.id) != "undefined")
      Api.put({ url: '/account/add', params: steps })
        .then(data => {
          console.log(data);
        })
        .catch(err => {
          console.log(err);
        });
  }

  const registerAccount = (ev) => {
    ev.preventDefault();

    const params = window.location.href.split("?"),
      form = {};

    for (let i = 0; i < ev.target.length; i++) {
      if (ev.target[i].name != "")
        form[ev.target[i].name] = ev.target[i].value;
    }

    steps.webhook = "https://api-rest.signuscorp.com/webhook/eyJpZF9lbXByZXNhIjoxLCJ3ZWJob29rIjoiNjMwNjlhYzU2MWM3OCJ9";
    Api.post({ url: '/account/funnel', params: steps })
      .then(data => {

        if (params.length > 1) {
          window.location.href = `/contact?id=${data.record}&channel=${form.channel}&${params[1]}`;
        } else {
          window.location.href = `/contact?id=${data.record}&channel=${form.channel}`;
        }
      })
      .catch(err => {
        console.log(err);
      });
  }

  const { t } = useTranslation(),
    [isLoaded, set_isLoaded] = React.useState(false),
    [steps, setData] = React.useState(async () => {
      db.steps.get(localStorage.getItem("wizardID")).then(dat => {
        setData(dat);
        set_isLoaded(true);
      });
    });

  React.useEffect(() => {

    db.steps.get(localStorage.getItem("wizardID")).then(dat => {

      if (typeof (dat) == "undefined") {
        db.steps.add(steps);
      } else {
        db.steps.update(localStorage.getItem("wizardID"), steps);
      }

      try {
        steps.currPack = steps.packs.filter(fil => fil.id_paquete == steps.plan)[0];
      } catch (e) { }

      //saveAccount(steps);
    });
  });

  return (
    <div>
      <div style={{ Index: "-1", height: window.innerHeight, backgroundImage: "url('https://files.signuscorp.com/?business=1&file=MTYzMTdlMWZjYmI5ODc=')", backgroundSize: 'cover', "-webkit-filter": 'blur(2px)' }}>
        <div style={{ background: "#000", opacity: "0.7", height: window.innerHeight }}></div>
      </div>

      <div class="row content-register" style={{ borderRadius: "20px", left: "15%", marginTop: "7.5%", height: "70%", width: "70%", background: "white", top: "0px", zIndex: "2", position: "absolute", "-webkit-filter": 'blur(0px) !important' }}>
        <div class="col-lg-4" style={{ borderRadius: "20px 0px 0px 20px", backgroundImage: "url('https://files.signuscorp.com/?business=1&file=MTYzMTY5YmNlNWE0YTM=')", backgroundSize: 'cover' }}>
        </div>
        <div class="col-lg-8" style={{ height: "100%", overflow: "auto" }}>
          <form class="row" onSubmit={registerAccount} style={{ marginTop: "30px", marginLeft: "5%", width: "90%" }}>
            <div class="col-md-12">
              <h2 class="mb-0">Bienvenido a SignusEducation</h2>
              <p class="lead mb-0">Por favor completa tus datos, y a continuación elije que canal prefieres para comunicarnos.</p><br />
            </div>
            <div class="form-group col-md-6">
              <label>Nombre de la institución</label>
              <input id="form_name" type="text" defaultValue={steps.company} name="company" class="form-control" placeholder="Ingrese el nombre de su negocio o empresa" required="required" data-error="Valor requerido."
                onChange={e => setData((prevState) => ({ ...prevState, company: e.target.value }))} />
              <div class="help-block with-errors"></div>
            </div>
            <div class="form-group col-md-6">
              <label>Teléfono</label>
              <input id="form_name" defaultValue={steps.phone} type="text" name="phone" class="form-control" placeholder="Ingrese un número de teléfono" required="required" data-error="Valor requerido."
                onChange={e => setData((prevState) => ({ ...prevState, phone: e.target.value }))} />
              <div class="help-block with-errors"></div>
            </div>
            <div class="form-group col-md-6">
              <label>Nombre</label>
              <input id="form_name" defaultValue={steps.name} type="text" name="name" class="form-control" placeholder="Ingrese su nombre" required="required" data-error="Valor requerido."
                onChange={e => setData((prevState) => ({ ...prevState, name: e.target.value }))} />
              <div class="help-block with-errors"></div>
            </div>
            <div class="form-group col-md-6">
              <label>Correo electrónico</label>
              <input id="form_name" defaultValue={steps.business_email} type="email" name="email" class="form-control" placeholder="Ingrese un correo electrónico" required="required" data-error="Valor requerido."
                onChange={e => setData((prevState) => ({ ...prevState, business_email: e.target.value }))} />
              <div class="help-block with-errors"></div>
            </div>
            <div class="form-group col-md-6">
              <label>País</label>
              <select class="form-control" data-error="Valor requerido."
                defaultValue={steps.country}
                onChange={e => setData((prevState) => ({ ...prevState, country: e.target.value }))} >
                <option selected disabled required>Elija su país</option>
                {isLoaded && steps.countries.map((con) => {
                  return <option selected={con.id == steps.country} value={con.id}>{con.nom}</option>
                })}
              </select>
              <div class="help-block with-errors"></div>
            </div>
            <div class="form-group col-md-6">
              <label>¿Cómo te contactamos?</label>
              <select class="form-control" name="channel" data-error="Valor requerido.">
                <option selected value="call">Recibir una llamada</option>
                <option value="videocall">Coordinar una videollamada</option>
                <option value="whatsapp">Escribir por Whatsapp</option>
                <option value="mail">Recibir más información por correo</option>
              </select>
              <div class="help-block with-errors"></div>
            </div>
            <div class="col-md-12 mt-5" style={{ textAlign: "right" }}>
              <button class="btn btn-primary"><span>Continuar</span></button>
              <br /><br /><br />
            </div>
          </form>
        </div>
      </div>
    </div >
  );
}

export default Register;
